module.exports = __webpack_public_path__ + "static/media/Nunito-Regular.dba92cb9.ttf";